
export default {
  props: {
    to: String,
    text: String,
    NoRule: {
      type: Boolean,
      default: () => false,
    },
  },
};
